export default __webpack_public_path__ + "static/media/white-close.fc58b1fd.svg";